"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationAuthManager = void 0;
const auth_1 = require("./auth");
class ApplicationAuthManager {
    constructor(config) {
        this.config = config;
        this.auth = new auth_1.Auth(config);
    }
    bootstrap(applicationBootstrapFunction) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (window.location.pathname == "/auth-callback") {
                const urlParams = new URLSearchParams(window.location.search);
                const code = urlParams.get("code");
                yield this.auth.completeAuthentication(code, () => __awaiter(this, void 0, void 0, function* () {
                    window.location.replace("/");
                }), () => { });
                return;
            }
            for (const excludedPath of (_a = this.config.excludedPaths) !== null && _a !== void 0 ? _a : []) {
                if (this.trimWithChar(window.location.pathname, "/").startsWith(this.trimWithChar(excludedPath, "/"))) {
                    applicationBootstrapFunction();
                    return;
                }
            }
            yield this.processAuthentication(applicationBootstrapFunction);
        });
    }
    getUser() {
        return this.auth.getUser();
    }
    logout() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.auth.logout();
        });
    }
    get accessToken() {
        return this.auth.accessToken();
    }
    processAuthentication(applicationBootstrapFunction) {
        return __awaiter(this, void 0, void 0, function* () {
            const user = yield this.auth.initialize();
            if (user) {
                // access token is available
                applicationBootstrapFunction();
            }
            else {
                // should never reach here
                console.log("Unexpected exception while authentication");
            }
        });
    }
    trimWithChar(s, char) {
        if (s.startsWith(char)) {
            s = s.slice(1);
        }
        if (s.endsWith(char)) {
            s = s.slice(0, s.length - 1);
        }
        return s.toLowerCase();
    }
}
exports.ApplicationAuthManager = ApplicationAuthManager;
